// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import VueApexCharts from 'vue-apexcharts'

// Import main SCSS
import 'vuetify/dist/vuetify.min.css'
import './assets/scss/App.scss'

// Import Vuetify
import Vuetify from 'vuetify'
import Notifications from 'vue-notification'

// Import Components
import exBreadcrumb from './components/ui/Breadcrumb'
import exCard from './components/ui/Card'
import exSeparator from './components/ui/Separator'
import exNotFound from './components/ui/NotFound'

// Use Components
Vue.component('apexchart', VueApexCharts)
Vue.component('ex-breadcrumb', exBreadcrumb)
Vue.component('ex-card', exCard)
Vue.component('ex-separator', exSeparator)
Vue.component('ex-not-found', exNotFound)

Vue.config.productionTip = false

Vue.use(Vuetify)
Vue.use(Notifications)
/* eslint-disable no-new */
new Vue({
  vuetify: new Vuetify({
    theme: {
      dark: true
    }}),
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js